import { useGetToolErrors } from '@/apis/agency/systemSentiment/hook';
import Pagination, { usePagination } from '@/components/Common/Pagination';
import { Box, Chip, Skeleton, Stack, Typography } from '@mui/material';

export default function ToolErrors({ filters }: { filters: Record<string, any> }) {
  const { currentPage: page, perPage, setPage, setPerPage } = usePagination();
  const { data: toolErrors, isLoading } = useGetToolErrors({
    page,
    per_page: perPage,
    filter: filters
  });

  const renderSkeleton = () => {
    return Array.from({ length: 5 }).map((_, i) => (
      <Stack
        key={i}
        direction='row'
        p={2}
        border='1px solid #F3F4F6'
        bgcolor='#F3F4F6'
        borderRadius={2}
        justifyContent='space-between'
      >
        {/* Left section */}
        <Stack direction='row' gap={1} alignItems='center'>
          <Skeleton variant='text' width={120} height={24} />
          <Skeleton variant='rounded' width={80} height={24} sx={{ borderRadius: '24px' }} />
        </Stack>

        {/* Right section */}
        <Box textAlign='right'>
          <Skeleton variant='text' width={30} height={24} />
          <Skeleton variant='text' width={50} height={16} />
        </Box>
      </Stack>
    ));
  };

  return (
    <Box p={3} border='1px solid #ECECEC' borderRadius={2} bgcolor='#fff' width='100%'>
      {/* Title */}
      {isLoading ? (
        <Skeleton variant='text' width={220} height={28} sx={{ mb: 2 }} />
      ) : (
        <Typography fontSize={20} fontWeight={500} mb={2}>
          Tool Error Map
        </Typography>
      )}

      <Stack gap={2}>
        {isLoading
          ? renderSkeleton()
          : toolErrors?.data?.map((item) => {
              return (
                <Stack
                  key={item.tool}
                  direction='row'
                  p={2}
                  border='1px solid #F3F4F6'
                  bgcolor='#F3F4F6'
                  borderRadius={2}
                  justifyContent='space-between'
                >
                  <Stack direction='row' gap={1}>
                    <Typography fontWeight={500}>{item.tool}</Typography>
                    <Chip
                      label={item.executor_label}
                      size='small'
                      sx={{
                        fontSize: 12,
                        borderRadius: '24px',
                        bgcolor: '#F3F4F6',
                        border: '1px solid #e6e5e5'
                      }}
                    />
                  </Stack>

                  <Box textAlign='right'>
                    <Typography color='error.main' fontWeight={500}>
                      {item.error_count}
                    </Typography>
                    <Typography fontSize={12}>errors</Typography>
                  </Box>
                </Stack>
              );
            })}
      </Stack>

      {/* Pagination */}
      {isLoading ? (
        <Stack direction='row' justifyContent='center' mt={2}>
          <Skeleton variant='rounded' width={200} height={32} />
        </Stack>
      ) : (
        <Pagination
          totalPages={toolErrors?.meta?.total_pages}
          totalCount={toolErrors?.meta?.total_count ?? 0}
          currentPage={page}
          perPage={perPage}
          onChange={setPage}
          onPerPageChange={setPerPage}
        />
      )}
    </Box>
  );
}
